import React, { useState, useEffect } from 'react'; // React State Management
import { Container, Col, Modal, Row, Form, Button} from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import { saveSettings } from '../../apis/settingApi';

export const SaveTableSettingsModal = ({show, setShow, gridParams, tableType}) => 
{
    const [filters, setFilters] = useState({});
    const [sortModel, setSortModel] = useState([]);
    
    
    useEffect(() => {        
        if (show && gridParams?.api) {
            setFilters(gridParams.api.getFilterModel() || {});
            setSortModel(gridParams.api.getColumnState().filter(col => col.sort) || []);
        }
    }, [show, gridParams]);

    const handleSubmit = async (event) => {
        event.preventDefault();

        const settings =  {[tableType]:{filters: {...filters}, sort: sortModel}};
        const response = await saveSettings(settings)
        setShow(false);
    }

    const handleClose = () => {
        setShow(false);
    }

    return <>
        <Modal show={show} size="lg" onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Save Filters</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container fluid className="p-5 bg-light">
                    {
                        Object.keys(filters).length > 0  || sortModel.length > 0 ?
                            <>
                            <Row xs={12} sm={12} md={12} lg={12}>
                                <Form onSubmit={handleSubmit}>
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                        {
                                            Object.keys(filters).length > 0 ? 
                                                <Table bordered hover size = "sm" className='settings-table'>
                                                    <thead>
                                                        <tr>
                                                            <th>Filter</th>
                                                            <th>Filter Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    {
                                                        Object.keys(filters).map(key => (
                                                            <tr key={key}>
                                                                <td>{key.charAt(0).toUpperCase() + key.slice(1)}</td>
                                                                {
                                                                    filters[key].filterType === 'date' ?<td>{new Date(filters[key].dateFrom).toLocaleDateString()}</td>:
                                                                    <>
                                                                        <td>{filters[key].filter ? filters[key].filter : filters[key]}</td>
                                                                    </>
                                                                }
                                                            </tr>
                                                        ))
                                                    }
                                                    </tbody>
                                                </Table>
                                                :<>No Filters Applied</>
                                        }
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} sm={12} md={12} lg={12}>
                                        {sortModel.length > 0 ?
                                            <Table bordered hover size = "sm" className='settings-table'>
                                                <thead>
                                                    <tr>
                                                        <th>Field</th>
                                                        <th>Order</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        sortModel.map(({ colId, sort }) => (
                                                            <tr key={colId}>
                                                                <td>{colId}</td>
                                                                <td>{sort}</td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </Table> : <>No Sorting Applied</>
                                    }
                                            
                                        </Col>
                                    </Row>
                                    <Row xs={12} sm={12} md={12} lg={12}>
                                        <Col className="text-end">
                                            <Button type="submit" disabled={Object.keys(filters).length === 0 && sortModel.length === 0}>Save</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Row>
                            
                            </>
                            : <>No Filters or Sorting Applied</>
                    }
                    
                </Container>
            </Modal.Body>
        </Modal>
    </>

}
    